
import { defineComponent } from 'vue';
import IconMagneto from "@/components/icons/IconMagneto.vue";
import IconSlide from "@/components/icons/IconSlide.vue";
import IconRoboClock from "@/components/icons/IconRoboClock.vue";

export default defineComponent({
  name: 'FeaturesSection',
  components: {
    IconMagneto,
    IconSlide,
    IconRoboClock
  }
});
